import { Box, Button, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { ShowOnlyActivesCheckbox } from "@/controls/filters/ShowOnlyActivesCheckbox";

interface RollMaterialsToolbarProps {
	search: string;
	onSearchChange: (value: string) => void;
	onlyActives: boolean;
	onOnlyActivesChange: (value: boolean) => void;
	onAdd: () => void;
}

export const RollMaterialsToolbar = ({
	search,
	onSearchChange,
	onlyActives,
	onOnlyActivesChange,
	onAdd,
}: RollMaterialsToolbarProps) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 2,
				mb: 1,
			}}
		>
			<TextField
				size="small"
				placeholder="Search..."
				value={search}
				onChange={(e) => onSearchChange(e.target.value)}
				sx={{ width: 200 }}
			/>

			<ShowOnlyActivesCheckbox
				checked={onlyActives}
				onChange={onOnlyActivesChange}
			/>

			<Box sx={{ flex: 1 }} />

			<Button
				variant="contained"
				color="primary"
				startIcon={<AddIcon />}
				onClick={onAdd}
				size="small"
			>
				ADD ROLL MATERIAL
			</Button>
		</Box>
	);
};
